import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";


const Button = styled.button`
            background: #efefef;
            color: #002666;
            font-weight: bold;
            width: 200px;
            height: 60px;
            border: 0;
            border-top-right-radius: 5px;
			border-bottom-right-radius: 5px;
`;

function Btn({ href, title, style, type, onClick, ...props }) {
	if (href) {
		return (
			<Link to={href}>
				<Button type={type} onClick={onClick} style={style} {...props}>{title}</Button>
			</Link>
		)
	} else {
		return <Button type={type} onClick={onClick} style={style} {...props}>{title}</Button>
	}
}

export default Btn;
